import { useState } from "react";
import { toast } from "sonner";
import { Star } from "lucide-react";
import { api, errMsg, useApi } from "@/lib/api";
import { UserAvatar } from "@/components/common";
import { Textarea } from "@/components/ui/textarea";
import { fmtDate } from "@/components/EventCard";

export const Stars = ({ value = 0, onChange, size = "h-4 w-4" }) => (
  <div className="flex gap-0.5">
    {[1, 2, 3, 4, 5].map((n) => (
      <button key={n} type="button" disabled={!onChange} onClick={() => onChange?.(n)} data-testid={onChange ? `review-star-${n}` : undefined}>
        <Star className={`${size} ${n <= Math.round(value) ? "fill-[#FF5C00] text-[#FF5C00]" : "text-stone-300"}`} />
      </button>
    ))}
  </div>
);

export const ReviewItem = ({ r }) => (
  <div data-testid={`review-${r.id}`} className="flex gap-3 py-4 border-b border-stone-100 last:border-0">
    <UserAvatar user={r.reviewer} className="h-9 w-9" />
    <div className="min-w-0">
      <div className="flex items-center gap-2"><span className="font-semibold text-sm">{r.reviewer?.name || "Member"}</span><Stars value={r.rating} size="h-3 w-3" /></div>
      {r.text && <p className="text-sm text-stone-600 mt-1">{r.text}</p>}
      <p className="font-mono text-[10px] text-stone-400 mt-1">{fmtDate(r.created_at, "MMM d, yyyy")}</p>
    </div>
  </div>
);

export const EventReviews = ({ eventId, canReview }) => {
  const { data, refetch } = useApi(`/events/${eventId}/reviews`);
  const [rating, setRating] = useState(5);
  const [text, setText] = useState("");
  const submit = async () => {
    try {
      await api.post(`/events/${eventId}/reviews`, { rating, text: text || null });
      toast.success("Thanks for the review");
      setText("");
      refetch();
    } catch (e) { toast.error(errMsg(e)); }
  };
  const reviews = data?.reviews || [];
  return (
    <section data-testid="event-reviews">
      <h3 className="font-display text-2xl font-bold">Reviews</h3>
      {canReview && (
        <div className="mt-4 p-4 rounded-2xl bg-stone-100 space-y-3">
          <Stars value={rating} onChange={setRating} size="h-5 w-5" />
          <Textarea data-testid="review-text-input" value={text} onChange={(e) => setText(e.target.value)} placeholder="How was it?" className="bg-white rounded-xl" />
          <button data-testid="review-submit-btn" onClick={submit} className="px-5 py-2 rounded-full bg-stone-900 text-white text-sm font-semibold hover:bg-[#FF5C00] transition-colors">Post review</button>
        </div>
      )}
      {reviews.length ? reviews.map((r) => <ReviewItem key={r.id} r={r} />) : <p className="text-sm text-stone-500 mt-3">No reviews yet.</p>}
    </section>
  );
};
